import { PolicyType } from '@aaa-ncnu-ie/mypolicy-api-customers';
import { PropertyPolicy } from '@aaa-ncnu-ie/mypolicy-api-policies';
import { Stack } from '@mui/material';
import React from 'react';

import DiscountsCard from '../../../components/InfoCards/DiscountsCard';
import colors from '../../../constants/colors';
import {
  policyTypeMap,
  policyTypeMapSelector,
} from '../../../utils/policyTypeUtil';
import HeaderTypography from '../HeaderTypography';
import PolicyDetailsCard from '../PolicyDetailsCard';
import Details from './Details';

interface Props {
  propertyPolicy: PropertyPolicy;
}

const PropertyPolicyDetails: React.FC<Props> = ({ propertyPolicy }) => {
  const policyTitleIndex = policyTypeMapSelector(
    propertyPolicy.policySummary.policyTypeCd,
    propertyPolicy.policySummary.typeOfPolicy
  );
  const policyTitle = policyTypeMap[policyTitleIndex].title;

  return (
    <Stack
      direction="column"
      spacing={2}
      sx={{
        width: 1,
        backgroundColor: colors.csaaGray,
        px: { mobile: 2, desktop: 7 },
        pt: { mobile: 3, tablet: 2, desktop: 9 },
        pb: 3,
      }}
    >
      <HeaderTypography text={`${policyTitle} policy`} />
      <Stack
        direction={{ mobile: 'column', desktop: 'row' }}
        spacing={3}
        sx={{
          width: 1
        }}
      >
        <Stack spacing={{ mobile: 2, tablet: 3 }} sx={{
          width: 1
        }}>
          <PolicyDetailsCard policy={propertyPolicy} />
          <Details data={propertyPolicy} />
        </Stack>
        <Stack
          spacing={3}
          data-testid="discountsCardContainer"
          sx={{ maxWidth: { mobile: 1, desktop: 358 }, width: 1 }}
        >
          {propertyPolicy.discounts.length > 0 && (
            <DiscountsCard
              discounts={propertyPolicy.discounts}
              policyType={PolicyType.Property}
            />
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};
export default PropertyPolicyDetails;
